import { URLPattern } from 'urlpattern-polyfill';

/**
 * Installs the WHATWG `URLPattern` polyfill on `globalThis` when the host
 * browser lacks a native implementation.
 *
 * `@lit-labs/router` calls `new URLPattern(...)` when `<fm-app>` registers
 * its route table. Safari before version 26 ships no native `URLPattern`,
 * so without this the router throws a `ReferenceError`, no route resolves,
 * and the SPA renders a blank page.
 *
 * Exposed as a function that callers invoke explicitly — rather than a bare
 * side-effect import — so the binding is referenced and esbuild cannot
 * tree-shake the installation out of the shipped bundle. `app.ts` (the
 * bundle entry) and `jest.setup.ts` (the test harness) share this single
 * installation path.
 */
export function installUrlPatternPolyfill (): void {
    if (typeof Reflect.get(globalThis, 'URLPattern') === 'undefined') {
        Reflect.set(globalThis, 'URLPattern', URLPattern);
    }
}
